import dayjs from 'dayjs';
import { UiText } from '@frontend/znanie-uikit';

import LayoutConfines from 'components/layout/LayoutConfines';

import { blurDataURL, ImageProxy } from 'components/common/ImageProxy';
import { Link } from 'components/common/Link';
import { LinkArrow } from 'components/common/LinkArrow';

import { PostType } from 'graphql/types';

import { trackAnalyticsData, AnalyticsEvent } from 'utils/analytics';

import css from './PostsOnMain.module.scss';

interface IProps {
  posts: PostType[];
}

export default function PostsOnMain({ posts }: IProps) {
  const handlePostClick = (post: PostType) => {
    const { slug, publishedAt } = post;

    trackAnalyticsData(AnalyticsEvent.MAIN_NEWS_ITEM_CLICK, {
      slug,
      publishedAt,
    });
  };

  const handleAllPostsClick = () => {
    trackAnalyticsData(AnalyticsEvent.MAIN_NEWS_SHOW_ALL_CLICK);
  };

  return (
    <div className={css.block}>
      <LayoutConfines>
        <LinkArrow
          title="Новости"
          href="/news"
          testId="News-main"
          handleClick={handleAllPostsClick}
        />
        <div className={css.list}>
          {posts.map((p, i) => (
            <Link
              href={`/news/${p.slug}`}
              key={`post-main-item-${i}`}
              onClick={() => {
                handlePostClick(p);
              }}
            >
              <div className={css.postItem}>
                <div className={css.postPicture}>
                  <ImageProxy
                    legacy
                    src={
                      (p.mobileImageUrl ? p.mobileImageUrl : p.imageUrl) || ''
                    }
                    alt={`Изображение новости: ${p.title}`}
                    objectFit="cover"
                    objectPosition="center"
                    placeholder="blur"
                    blurDataURL={blurDataURL}
                    layout="fill"
                    sourceWidth={174}
                    sourceHeight={174}
                    resizingType="fill"
                    gravityType="ce"
                  />
                </div>
                <div className={css.postInfo}>
                  <UiText size="small_x" color="grey" weight="normal">
                    {dayjs(p.publishedAt).format('DD MMMM YYYY')}
                  </UiText>
                  <UiText
                    className={css.postTitle}
                    size="small_plus"
                    weight="normal"
                  >
                    <UiText.Wrapper withFormat size={90} disableMore>
                      {p.title || ''}
                    </UiText.Wrapper>
                  </UiText>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </LayoutConfines>
    </div>
  );
}
